export enum DocumentTypeKey {
    Chain = 'chain',
    History = 'history',
}
